import Consorcio from '@/app/components/Consorcio'
import Head from 'next/head'

export default function ConsorcioPage() {
  return (
    <>
      <Head>
        <title>Azul Agro - Consórcio</title>
        <meta name="description" content="Entre em contato com a Azul Agro para tirar suas dúvidas, solicitar informações sobre nossos produtos ou receber suporte técnico. Estamos prontos para ajudar você a otimizar suas operações agrícolas com nossas soluções de alta performance." />
        <link rel="preload" as="image" href={"https://gabcomercio.azureedge.net/azul-agro/desktop/consorcio/introSection.webp"} media="(min-width: 1140px)" />
        <link rel="preload" as="image" href={"https://gabcomercio.azureedge.net/azul-agro/tablet/consorcio/introSection.webp"} media="(min-width: 540px) and (max-width: 1139px)" />
        <link rel="preload" as="image" href={"https://gabcomercio.azureedge.net/azul-agro/mobile/consorcio/introSection.webp"} media="(max-width: 539px)" />
      </Head>
      <Consorcio />
    </>
  )
}
